import React, { JSX } from "react";
import { Dialog, Paper, styled, SxProps, useMediaQuery, useTheme } from "@mui/material";
import { Theme } from "@mui/system";


export interface ModalProps {
    open:boolean;
    handleClose:(parm?:any) => void;
    handleOnKeyDown?:(event:any)=>void;
    component:JSX.Element;
    width:"xs"|"sm"|"md"|"lg"|"xl",
    heigth:'auto'|'100%'
    sx?:SxProps<Theme>
    /**xs extra pequeno 0px
     * sm pequeno 600px
     * md medio 960px
     * lg grande 1280px
     * xl extra grande 1920px
     */
}

export default function Modal(props:ModalProps) {
    const { open, handleClose, component, width,heigth,handleOnKeyDown,sx } = props;

    const MyPaper = styled(Paper)(({ theme }) => ({
        height:heigth
    }))
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(width));
    return (
        <Dialog 
            id="modal-livre"
            fullWidth
            fullScreen={fullScreen}
            maxWidth={width} 
            open={open} 
            onClose={(e,reason)=>{
                if (reason && reason === "backdropClick") 
                    return;                  
                handleClose()
            }}
            PaperComponent={MyPaper}
            onKeyDown={handleOnKeyDown}
            sx={sx}
        >
            {component}
        </Dialog>
    )
}
